import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { dufyAdmon } from "./constants";

// Configuración para la empresa principal (Dufy)
const firebaseConfigDufy = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Configuración para la empresa secundaria (Liba)
const firebaseConfigLiba = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY_LIBA,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_LIBA,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_LIBA,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_LIBA,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_LIBA,
    appId: process.env.REACT_APP_FIREBASE_APP_ID_LIBA
};

/**
 * Obtiene la instancia de Firebase correcta según si es para Dufy Admon o no.
 * Reutiliza la instancia si ya fue creada para evitar errores.
 * @param {boolean} isDufy - True si se debe usar la config de Dufy, false para la de Liba.
 * @returns {{app: FirebaseApp, auth: Auth, db: Firestore}}
 */
export const getFirebaseServices = (isDufy) => {
    // 1. Determina el nombre de la app y la configuración a usar
    const appName = isDufy ? 'dufyApp' : 'libaApp';
    const selectedConfig = isDufy ? firebaseConfigDufy : firebaseConfigLiba;

    // 2. Revisa si una app con ese nombre ya fue inicializada
    const existingApp = getApps().find(app => app.name === appName);

    // 3. Si ya existe, la obtiene. Si no, la inicializa con su nombre único.
    const app = existingApp ? getApp(appName) : initializeApp(selectedConfig, appName);

    // 4. Devuelve los servicios para la app seleccionada
    return {
        app,
        auth: getAuth(app),
        db: getFirestore(app),
    };
};

// --- Exportaciones por Defecto (Opcional) ---
// Puedes mantener una exportación por defecto para usar antes del login
// o en partes de la app que no cambian. Por defecto, usará la de Dufy.
const defaultServices = getFirebaseServices(dufyAdmon);
export const auth = defaultServices.auth;
export const db = defaultServices.db;
